module.exports = __webpack_public_path__ + "img/white.adcc6af0.png";